export default __webpack_public_path__ + "static/media/cranium-man.caaa8a09.png";